import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _excluded = ["children"];
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import React, { createContext, useMemo } from "react";
import omit from "lodash/omit";
import PropTypes from "prop-types";
import { simpleNamedComponentMap as globalComponentMap } from "../render/componentMap";
import { resolveComponent as defaultResolveComponent } from "../render/renderMetadataHelper";
export var ComponentMapContext = createContext(defaultResolveComponent);
export var extendResolver = function (componentMapExtensions, resolveComponent) {
  var componentMapExtensionsOnly = omit(componentMapExtensions, _Object$keys(globalComponentMap));
  return function (component, datatype, componentMap, type, metadataPath, componentProps) {
    return resolveComponent(component, datatype, _objectSpread(_objectSpread({}, componentMapExtensionsOnly), componentMap), type, metadataPath, componentProps);
  };
};
var componentMapProviderDefaultProps = {
    resolveComponent: defaultResolveComponent
  },
  componentMapProviderPropTypes = {
    resolveComponent: PropTypes.func,
    componentMapExtensions: PropTypes.objectOf(PropTypes.elementType.isRequired)
  };
export var ComponentMapProvider = function (_ref) {
  var children = _ref.children,
    _ref2 = _objectWithoutProperties(_ref, _excluded),
    componentMapExtensions = _ref2.componentMapExtensions,
    resolveComponent = _ref2.resolveComponent,
    customResolveComponent = useMemo(function () {
      return componentMapExtensions ? extendResolver(componentMapExtensions, resolveComponent) : resolveComponent;
    }, [resolveComponent, componentMapExtensions]);
  return React.createElement(ComponentMapContext.Provider, {
    value: customResolveComponent
  }, children);
};
ComponentMapProvider.propTypes = componentMapProviderPropTypes, ComponentMapProvider.defaultProps = componentMapProviderDefaultProps, ComponentMapProvider.__docgenInfo = {
  description: "",
  methods: [],
  displayName: "ComponentMapProvider",
  props: {
    resolveComponent: {
      defaultValue: {
        value: "defaultResolveComponent",
        computed: !0
      },
      type: {
        name: "func"
      },
      required: !1,
      description: "An optional callback function to resolve components from string and/or datatype"
    },
    componentMapExtensions: {
      type: {
        name: "objectOf",
        value: {
          name: "elementType"
        }
      },
      required: !1,
      description: "Extensions to the default component map which will be used when resolving metadata"
    }
  }
}, ComponentMapProvider.__docgenInfo = {
  componentName: "ComponentMapProvider",
  packageName: "@jutro/uiconfig",
  description: "",
  displayName: "ComponentMapProvider",
  methods: [],
  actualName: "ComponentMapProvider",
  props: {
    resolveComponent: {
      type: {
        name: "func"
      },
      required: !1,
      description: "An optional callback function to resolve components from string and/or datatype",
      defaultValue: {
        value: "defaultResolveComponent",
        computed: !0
      }
    },
    componentMapExtensions: {
      type: {
        name: "objectOf",
        value: {
          name: "elementType"
        }
      },
      required: !1,
      description: "Extensions to the default component map which will be used when resolving metadata"
    }
  }
};